export enum FeatureFlag {
  EPA_ENABLED = 'epa-enabled',
}

export const featureFlagDefaults: Record<FeatureFlag, boolean> = {
  [FeatureFlag.EPA_ENABLED]: false,
};
